<template>
  <form
    :action="route('admin.stock-move.index')"
    method="GET"
    class="flex items-center flex-wrap -mx-2"
  >
    <div class="w-1/4 px-2">
      <v-select
        v-model="selectedStatus"
        :multiple="true"
        :options="statuses"
        name="status"
        :reduce="(item) => item.value"
      >
      </v-select>

      <input
        v-for="item in selectedStatus"
        type="hidden"
        name="status[]"
        :key="item"
        :value="item"
      />
    </div>
    <div class="w-1/4 px-2">
      <v-select
        v-model="selectedDocType"
        :multiple="true"
        :options="docTypes"
        :reduce="(item) => item.value"
      >
      </v-select>

      <input
        v-for="item in selectedDocType"
        type="hidden"
        name="doc_type[]"
        :key="item"
        :value="item"
      />
    </div>

    <button type="submit" class="btn btn-sm">Filter</button>
  </form>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
  },

  props: {
    statuses: {
      required: true,
      type: Array,
    },
    docTypes: {
      required: true,
      type: Array,
    },
    currentStatus: {
      required: false,
      default: [],
    },
    currentDocType: {
      required: false,
      default: [],
    },
  },

  data() {
    return {
      selectedStatus: [],
      selectedDocType: [],
    };
  },

  created() {
    if (this.currentStatus.length > 0) {
      this.selectedStatus = this.currentStatus;
    }

    if (this.currentDocType.length > 0) {
      this.selectedDocType = this.currentDocType;
    }
  },
};
</script>
